// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-scrollbar__wrap{width:300px;height:200px}.zhs-no-data .label{font-size:14px}.el-affix--fixed{position:fixed}", ""]);
// Exports
module.exports = exports;
